// TODO: Add more submission types once they're added to the API
// When adding a new submission type, SubmissionPermissionUtils and InternalUserSubmissionPermissionMap must be updated

export enum SubmissionTypeEnum {
  NameChange = 1,
  AddressChange = 2,
  UpdatePhoneNumber = 3,
  PersonalDetailsChange = 4,
  ChangeInvestmentInstructions = 5,
  RelationshipStatusChange = 6,
  BeneficiaryChange = 7,
  BankingInformation = 8,
  MemberSelfEnrolment = 9, // This is for IP only
  UpdateLegalFiduciary = 10,
  VariableBenefitConfiguration = 11,
  UpdateBeneficiariesVariableBenefit = 12,
  UpdateVariableBenefitAccountConfiguration = 13,
  VariableBenefitPaymentChange = 14,
  AnnuitySetup = 15,
  UpdateAnnuityBeneficiaries = 16,
  TransferIn = 17
}

export const SubmissionGroups = {
  PersonalSubmissions: [
    SubmissionTypeEnum.NameChange,
    SubmissionTypeEnum.PersonalDetailsChange,
    SubmissionTypeEnum.RelationshipStatusChange
  ] as const,
  ContactSubmissions: [SubmissionTypeEnum.AddressChange, SubmissionTypeEnum.UpdatePhoneNumber] as const,
  BankingSubmissions: [SubmissionTypeEnum.BankingInformation] as const,
  FiduciarySubmissions: [SubmissionTypeEnum.UpdateLegalFiduciary] as const
} as const;

export type SubmissionGroup = (typeof SubmissionGroups)[keyof typeof SubmissionGroups];
